import React, { Component } from "react"
import { connect } from "react-redux"
import { branch, compose, defaultProps, withProps } from "recompact"
import { withRouter } from "react-router-dom"
import get from "lodash/get"
import isEmpty from "lodash/isEmpty"
import { change, Field, getFormValues, submit } from "redux-form"
import moment from "moment"
import { LinkIcon } from "@infotech/uikit-icons"
import ModalDialogWindow from "src/components/modals/ModalDialogWindow"
import { reduxForm } from "src/engine/modules/entity/plugins"
import { Box } from "@infotech/uikit-grid"
import { Flex, ContentCell } from "src/components/Grid"
import entityApi from "src/hocs/entity"
import resourcesTypeModel from "src/models/resourceType"
import planEventTypesModel from "src/hocs/planEventTypes"
import eventTypes from "src/hocs/eventTypes"
import eventModel from "src/models/event"
import EventTypeSelect from "src/components/forms/EventTypeSelect"
import Fieldset from "@infotech/uikit-fieldset"
import EventDurationPicker from "src/components/forms/EventDurationPicker"
import { makeTransparent } from "src/containers/Calendar/helpers/eventToItem"
import makeNewEventInterval from "src/helpers/makeNewEventInterval"
import styles from "./styles.css"

const FORM_NAME = `createEvent`
const selectValues = getFormValues(FORM_NAME)
const submitActionCreator = () => submit(FORM_NAME)
const getTestAttribute = name => `planner_calendar_new_event_form_${name}`

class NewEventForm extends Component {
  handleClose = () => {
    const { onClose } = this.props

    onClose()
  }

  handleCreate = () => {
    const { submitForm } = this.props

    submitForm()
  }

  handleExpand = () => {
    const { onExpand, eventTypeId, startDateTime, endDateTime } = this.props

    onExpand({
      eventTypeId,
      startDateTime,
      endDateTime,
    })
  }

  render() {
    const {
      newEventParams: { resource },
      startDateTime,
      endDateTime,
      eventTypeId,
      resourceType: { data: resourceTypeData },
      eventTypeList,
      eventType,
      changeEventTypeId,
      durationChange,
    } = this.props
    const headerColor =
      !isEmpty(eventType) && makeTransparent(eventType.color, 0.4)
    return (
      <ModalDialogWindow
        noStyle
        onClose={this.handleClose}
        title="Новое событие"
        headerBackgroundColor={headerColor}
        onOk={{
          children: `СОЗДАТЬ`,
          onClick: this.handleCreate,
          disabled: false,
        }}
        onCancel={{
          children: `РАСШИРЕННЫЕ НАСТРОЙКИ`,
          onClick: this.handleExpand,
          withBorder: true,
          disabled: !eventTypeId,
        }}
      >
        <Box loose pl="2md" pr="2md" pt="1md">
          <Fieldset caption="Тип события*">
            <Field
              component={EventTypeSelect}
              name="eventTypeId"
              format={null}
              props={{
                placeholder: `Выберите тип события`,
                options: eventTypeList.map(item => ({
                  value: item.id,
                  label: item.name,
                  color: item.color,
                })),
              }}
              onChange={changeEventTypeId}
            />
          </Fieldset>
        </Box>
        <Box loose pl="2md" pr="2md">
          <EventDurationPicker
            startDateTime={startDateTime}
            endDateTime={endDateTime}
            maxExecutionTime={get(eventType, `maxExecutionTime`)}
            minExecutionTime={get(eventType, `minExecutionTime`)}
            eventTypeId={get(eventType, `id`)}
            noError
            onlyDays={get(eventType, `onlyDate`)}
            getTestAttribute={getTestAttribute}
            onDurationChange={durationChange}
            executionTime={(endDateTime - startDateTime) / 1000}
          />
        </Box>
        <Flex className={styles[`resource-wrapper`]}>
          <ContentCell className={styles[`icon-wrapper`]}>
            <LinkIcon size="medium" className={styles.contentIcon} />
          </ContentCell>
          <Flex column className={styles[`content-resource-wrapper`]}>
            <span className={styles[`content-resource-type`]}>
              {resourceTypeData && resourceTypeData.name}
            </span>
            <span className={styles[`content-resource-name`]}>
              {resource.title}
            </span>
          </Flex>
        </Flex>
      </ModalDialogWindow>
    )
  }
}

export default compose(
  withRouter,
  connect(),
  branch(
    ({ planId }) => !!planId,
    planEventTypesModel(({ newEventParams: { resource: { typeId } } }) => ({
      query: {
        query: `allowedResourceTypes=in=(${typeId})`,
        limit: -1,
      },
    })),
  ),
  eventTypes(({ newEventParams: { resource: { typeId } } }) => ({
    query: {
      query: `allowedResourceTypes=in=(${typeId})`,
      limit: -1,
    },
  })),
  connect(state => ({
    eventTypeId: get(selectValues(state), `eventTypeId`),
  })),
  withProps(({ planEventTypes, planId, eventTypes: { data }, eventTypeId }) => {
    const planEventTypesData = get(planEventTypes, `data`)
    const usePlanEventTypes =
      planId && planEventTypesData && !isEmpty(planEventTypesData)
    const eventTypeList = usePlanEventTypes ? planEventTypesData : data
    const eventType = eventTypeList.find(one => one.id === eventTypeId) || {}

    return {
      eventTypeList,
      eventType,
    }
  }),
  entityApi({
    to: `event`,
    model: eventModel,
    plugins: reduxForm(
      compose(
        defaultProps({
          validate: ({ startDateTime, endDateTime }, { eventType }) => {
            const errors = {}
            if (startDateTime === endDateTime) {
              errors.endDateTime = `Время начала и конца не могут совпадать`
            } else if (startDateTime > endDateTime) {
              errors.startDateTime = `Время начала не должно быть больше времени конца`
            }
            if (get(eventType, `onlyDate`)) {
              const isStartOnDayZeroPoint =
                moment(startDateTime)
                  .startOf(`day`)
                  .valueOf() === moment(startDateTime).valueOf()
              const isEndOnDayZeroPoint =
                moment(endDateTime)
                  .startOf(`day`)
                  .valueOf() === moment(endDateTime).valueOf()
              if (!isStartOnDayZeroPoint) {
                errors.startDateTime = `Задана опция "Использовать только дни". Событие должно начинаться только в 00:00`
              }
              if (!isEndOnDayZeroPoint) {
                errors.endDateTime = `Задана опция "Использовать только дни". Событие должно заканчиваться только в 00:00`
              }
            }
            return errors
          },
        }),
        withProps(
          ({
            workspace: { emit },
            planId,
            newEventParams: {
              startDateTime,
              endDateTime,
              resource: { uuid: resourceUuid },
            },
          }) => {
            const reduxFormConfig = {
              form: FORM_NAME,
              onSubmit(data, dispatch, props) {
                const {
                  event: {
                    api: { create },
                  },
                  handleItemAdd,
                  eventTypes,
                } = props
                const haveEventType = Boolean(
                  eventTypes && data && data.eventTypeId,
                )
                const nameByEventType = haveEventType
                  ? eventTypes.data.find(item => item.id === data.eventTypeId)
                  : { name: `` }
                emit(`save`)
                return create(
                  {
                    ...data,
                    ...(planId ? { planId: parseInt(planId, 10) } : {}),
                    name: nameByEventType.name,
                    withValidate: true,
                  },
                  handleItemAdd,
                )
              },
            }

            reduxFormConfig.initialValues = {
              startDateTime,
              endDateTime,
              resourceUuids: [resourceUuid],
            }

            return reduxFormConfig
          },
        ),
      ),
    ),
  }),
  entityApi(({ newEventParams: { resource: resourceType } }) => ({
    id: resourceType.typeId,
    to: `resourceType`,
    model: resourcesTypeModel,
  })),
  connect(
    state => ({
      startDateTime: get(selectValues(state), `startDateTime`),
      endDateTime: get(selectValues(state), `endDateTime`),
    }),
    { submitForm: submitActionCreator },
  ),
  connect(null, (dispatch, props) => ({
    changeEventTypeId: value => {
      const { startDateTime, endDateTime, eventTypeList } = props
      const eventType = eventTypeList.find(one => one.id === value) || {}

      // Изменение самого поля
      dispatch(change(FORM_NAME, `eventTypeId`, value))

      // Корректировка дат, если событие использует только дни
      const [newStartTime, newEndTime] = makeNewEventInterval({
        startTime: startDateTime,
        endTime: endDateTime,
        isDateOnly: get(eventType, `onlyDate`),
      })

      if (newStartTime !== startDateTime) {
        dispatch(change(FORM_NAME, `startDateTime`, newStartTime))
      }

      if (newEndTime !== endDateTime) {
        dispatch(change(FORM_NAME, `endDateTime`, newEndTime))
      }
    },
    // При изменении длительности, соответственно меняется дата окончания
    durationChange: value => {
      const { startDateTime } = props
      dispatch(
        change(FORM_NAME, `endDateTime`, moment(startDateTime + value * 1000)),
      )
    },
  })),
)(NewEventForm)
